@if (HasRequiredPermissions) {
@if (EntityInstance || isNew()) {
<!-- Conteneur principal avec layout flexbox -->
<div [fieldContext]="this" class="flex flex-col h-full">
  <!-- Titre fixe en dehors de la zone de défilement -->
  <div class="px-6 pt-4 pb-2">
    <h4 class="text-[0.9em] font-medium text-gray-500 z-[999]">
      @if (isNew()) {
      {{ 'entities.client.newEntity' | translate }}
      } @else {
      {{ 'entities.client.detailEntity' | translate }}
      }
    </h4>
    <div class="flex justify-between items-center">
      <button (click)="cancelEdit()" data-testid="detail-close" class="absolute top-2 right-2 text-gray-500 hover:text-gray-700 transition-colors">
        <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
        </svg>
      </button>
    </div>
  </div>
  <!-- Zone de contenu avec défilement -->
  <div class="{{Skin.detailContainer}} flex-1 overflow-auto">
    <!--  Conteneur desactivable -->
    <div class="{{this.UpdateMode}}">
      <!-- Profile Picture Section -->
      <div class="relative m-6 w-[160px] h-[170px] -mt-6 ml-16 overflow-hidden">
        <i class="far fa-building absolute inset-0 text-gray-400 text-[170px] flex items-center justify-center pointer-events-none"
          [ngClass]="{'hidden': imageUrl}"></i>
        <img [src]="imageUrl || ''" class="w-full object-cover" [ngClass]="{'hidden': !imageUrl}" />
        <div class="absolute bottom-0 left-0 flex">
          <input type="file" #fileInput accept="image/*" (change)="onFileSelected($event,'FK_Image_Logo')" class="hidden" />
          <button type="button" (click)="fileInput.click()"
            class="bg-teal-500 hover:bg-teal-800 text-white px-2 py-1 text-xs font-xs">
            <i class="fa fa-camera text-[0.9rem]"></i>
          </button>
          <button type="button" (click)="resetImage()" class="{{Skin.btnAlert}} px-2 py-1 text-xs font-xs">
            <i class="fas fa-times text-[0.9rem]"></i>
          </button>
        </div>
      </div>
      <!-- Client Infos Section -->
      <div class="mt-10">
        <h3 class="{{Skin.formSectionSmallTitle}}">
          <i class="far fa-building mr-2"></i> {{
          'vues.client.detail.sections.client-info' | translate
          }}
        </h3>
        <div class="space-y-2">
          <app-field-wrapper property="organizationName">
            <input type="text" autocomplete="off" onReady (autoBind)="bindingHandler($event, 'organizationName')"
              class="{{Skin.formInputSmallSize}}" [class.border-red-500]="hasValidationErrors('organizationName')">
          </app-field-wrapper>
          <app-field-wrapper property="prefix" class="relative z-10">
            <div class="relative">
              <input type="text" autocomplete="off" onReady (autoBind)="bindingHandler($event, 'prefix')"
                class="{{Skin.formInputSmallSize}} pr-8"
                [class.border-red-500]="domainError || hasValidationErrors('prefix')" />
              <!-- pastille × d'effacement -->
              @if (!isEmpty($safeNavigationMigration(editingEntity()?.prefix))) {
              <button type="button" (click)="clearDomain()"
                class="absolute right-2 top-1/2 -translate-y-1/2 text-gray-300 hover:text-gray-500">
                <i class="fas fa-times-circle"></i>
              </button>
              }
            </div>
            @if (domainError) {
            <p class="text-red-600 text-xs mt-1">
              {{ 'vues.client.detail.field-errors.prefix' | translate}}
            </p>
            }
          </app-field-wrapper>
        </div>
      </div>
      <!-- Status Section (modification seulement : la création force actif côté serveur) -->
      @if (!isNew()) {
      <div class="mt-10">
        <h3 class="{{Skin.formSectionSmallTitle}}">
          <i class="fas fa-toggle-on mr-2"></i>{{
          'vues.client.detail.sections.status' | translate
          }}
        </h3>
        <div class="space-y-2">
          <app-field-wrapper property="isActive">
            <input class="w-5 h-5 mr-2 cursor-pointer" type="checkbox" onReady
              (autoBind)="bindingHandler($event, 'isActive')">
          </app-field-wrapper>
        </div>
      </div>
      }
      <!-- Account Rep Section -->
      <div class="mt-10">
        <h3 class="{{Skin.formSectionSmallTitle}}">
          <i class="far fa-user mr-2"></i>{{
          'vues.client.detail.sections.account-rep' | translate
          }}
        </h3>
        <div class="space-y-2">
          <app-field-wrapper property="relatedTenant.accountRepresentative" label="Full Name">
            <input type="text" autocomplete="off" onReady
              (autoBind)="bindingHandler($event, 'relatedTenant.accountRepresentative')"
              class="{{Skin.formInputSmallSize}}"
              [class.border-red-500]="hasValidationErrors('relatedTenant.accountRepresentative')">
          </app-field-wrapper>
          <app-field-wrapper property="relatedTenant.accountEmail" label="Email">
            <input type="email" autocomplete="off" onReady
              (autoBind)="bindingHandler($event, 'relatedTenant.accountEmail')" class="{{Skin.formInputSmallSize}}"
              [class.border-red-500]="hasValidationErrors('relatedTenant.accountEmail')">
          </app-field-wrapper>
          <app-field-wrapper property="relatedTenant.accountPhoneNumber" label="Phone Number">
            <input type="tel" autocomplete="off" onReady
              (autoBind)="bindingHandler($event, 'relatedTenant.accountPhoneNumber')" class="{{Skin.formInputSmallSize}}"
              [class.border-red-500]="hasValidationErrors('relatedTenant.accountPhoneNumber')">
          </app-field-wrapper>
        </div>
      </div>
      <!-- Address Section -->
      <div class="mt-10">
        <h3 class="{{Skin.formSectionSmallTitle}}">
          <i class="fas fa-map-marker-alt mr-2"></i>{{
          'vues.client.detail.sections.address' | translate
          }}
        </h3>
        <div class="space-y-2">
          <app-field-wrapper property="relatedTenant.civicNumber" label="Civic Number">
            <input type="text" autocomplete="off" onReady (autoBind)="bindingHandler($event, 'relatedTenant.civicNumber')"
              class="{{Skin.formInputSmallSize}}"
              [class.border-red-500]="hasValidationErrors('relatedTenant.civicNumber')">
          </app-field-wrapper>
          <app-field-wrapper property="relatedTenant.street" label="Street">
            <input type="text" autocomplete="off" onReady (autoBind)="bindingHandler($event, 'relatedTenant.street')"
              class="{{Skin.formInputSmallSize}}" [class.border-red-500]="hasValidationErrors('relatedTenant.street')">
          </app-field-wrapper>
          <app-field-wrapper property="relatedTenant.officeNumber" label="Office Number">
            <input type="text" autocomplete="off" onReady
              (autoBind)="bindingHandler($event, 'relatedTenant.officeNumber')" class="{{Skin.formInputSmallSize}}"
              [class.border-red-500]="hasValidationErrors('relatedTenant.officeNumber')">
          </app-field-wrapper>
          <app-field-wrapper property="relatedTenant.city" label="City">
            <input type="text" autocomplete="off" onReady (autoBind)="bindingHandler($event, 'relatedTenant.city')"
              class="{{Skin.formInputSmallSize}}" [class.border-red-500]="hasValidationErrors('relatedTenant.city')">
          </app-field-wrapper>
          <app-field-wrapper property="relatedTenant.state" label="State">
            <input type="text" autocomplete="off" onReady (autoBind)="bindingHandler($event, 'relatedTenant.state')"
              class="{{Skin.formInputSmallSize}}" [class.border-red-500]="hasValidationErrors('relatedTenant.state')">
          </app-field-wrapper>
          <app-field-wrapper property="relatedTenant.country" label="Country">
            <input type="text" autocomplete="off" onReady (autoBind)="bindingHandler($event, 'relatedTenant.country')"
              class="{{Skin.formInputSmallSize}}" [class.border-red-500]="hasValidationErrors('relatedTenant.country')">
          </app-field-wrapper>
          <app-field-wrapper property="relatedTenant.postalCode" label="Postal Code">
            <input type="text" autocomplete="off" onReady (autoBind)="bindingHandler($event, 'relatedTenant.postalCode')"
              class="{{Skin.formInputSmallSize}}"
              [class.border-red-500]="hasValidationErrors('relatedTenant.postalCode')">
          </app-field-wrapper>
        </div>
      </div>
      <!-- Admin Tenant Infos Section (only visible in create mode) -->
      @if (isNew()) {
      <div class="mt-10">
        <h3 class="{{Skin.formSectionSmallTitle}}">
          <i class="far fa-user mr-2"></i>{{
          'vues.client.detail.sections.admin-tenant-infos' | translate
          }}
        </h3>
        <div class="space-y-2">
          <app-field-wrapper property="adminTenantInfoDTO.FullName" label="Full Name">
            <input type="text" autocomplete="off" onReady
              (autoBind)="bindingHandler($event, 'adminTenantInfoDTO.FullName')" class="{{Skin.formInputSmallSize}}"
              [class.border-red-500]="hasValidationErrors('adminTenantInfoDTO.FullName')">
          </app-field-wrapper>
          <app-field-wrapper property="adminTenantInfoDTO.Email" label="Email">
            <input type="email" autocomplete="off" onReady (autoBind)="bindingHandler($event, 'adminTenantInfoDTO.Email')"
              class="{{Skin.formInputSmallSize}}"
              [class.border-red-500]="hasValidationErrors('adminTenantInfoDTO.Email')">
          </app-field-wrapper>
          <app-field-wrapper property="adminTenantInfoDTO.PhoneNumber" label="Phone Number">
            <input type="tel" autocomplete="off" onReady (autoBind)="bindingHandler($event, 'adminTenantInfoDTO.PhoneNumber')"
              class="{{Skin.formInputSmallSize}}"
              [class.border-red-500]="hasValidationErrors('adminTenantInfoDTO.PhoneNumber')">
          </app-field-wrapper>
          <app-field-wrapper property="adminTenantInfoDTO.TwoFactorEnabled" label="Two-Factor Authentication (2FA)">
            <input class="w-5 h-5 mr-2 cursor-pointer" type="checkbox" onReady
              (autoBind)="bindingHandler($event, 'adminTenantInfoDTO.TwoFactorEnabled')">
          </app-field-wrapper>
          <app-field-wrapper property="adminTenantInfoDTO.Password" label="Password">
            <input type="password" autocomplete="off" onReady
              (autoBind)="bindingHandler($event, 'adminTenantInfoDTO.Password')" class="{{Skin.formInputSmallSize}}"
              [class.border-red-500]="hasValidationErrors('adminTenantInfoDTO.Password')">
          </app-field-wrapper>
          <app-field-wrapper property="adminTenantInfoDTO.ConfirmPassword" label="Confirm Password">
            <input type="password" autocomplete="off" onReady
              (autoBind)="bindingHandler($event, 'adminTenantInfoDTO.ConfirmPassword')"
              class="{{Skin.formInputSmallSize}}"
              [class.border-red-500]="hasValidationErrors('adminTenantInfoDTO.ConfirmPassword')">
          </app-field-wrapper>
        </div>
      </div>
      }
    </div>
  </div>
  <!-- Bandeau pour le nombre d'erreurs -->
  @if (generalErrorCount() > 0) {
  <div
    class="mb-1 p-1 bg-orange-100 text-red-700 border border-orange-300 rounded-full text-xs sticky bottom-14 z-10 py-1 -mt-1 z-20 text-center">
    <i class="fas fa-exclamation-triangle mr-1 ml-2"></i>
    {{ generalErrorCount() }} erreur(s) dans le formulaire
  </div>
  }
  <!-- Boutons en bas du formulaire - TOUJOURS VISIBLES -->
  <div class="bg-stone-50 w-full flex space-x-1 justify-center pt-2 border-t border-gray-200 pb-2">
    @if (HasEditPermission) {
    <button name="SaveButton" data-testid="detail-save"
      type="button" (click)="saveItem()"
      [disabled]="!isFormValid()"
      class="{{Skin.btnPrimary}} uppercase py-2 px-2">
      <i class="far fa-check-square mr-2"></i>
      {{ 'buttons.save' | translate }}
    </button>
    }
    @if (HasEditPermission) {
    <button name="SaveAndCloseButton" data-testid="detail-save-close"
      type="button" (click)="saveAndCloseItem()"
      [disabled]="!isFormValid()"
      class="{{Skin.btnPrimary}} uppercase py-2 px-2">
      <i class="far fa-check-square mr-2"></i>
      {{ 'buttons.save-and-close' | translate }}
    </button>
    }
    <button (click)="cancelEdit()" data-testid="detail-cancel" class="{{Skin.btnAlert}} uppercase py-2 px-2">
      <i class="fas fa-times mr-2"></i>
      {{ 'buttons.cancel' | translate }}
    </button>
  </div>
</div>
}
}